import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { SupplierBankModelType } from '@teinor/erp/types/company/supplier/supplierBank'
import { ComponentWithPermissions } from '../../../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalCECreditorBank from './ModalCECreditorBank'
import TwinTable from '../../../../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderBoolean, EditRow, DeleteRow } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import ModalDeleteCreditorBank from './ModalDeleteCreditorBank'

interface CreditorBanksProps extends ComponentWithPermissions {
    basicData: SupplierModelType | null
}

const CreditorBanks: React.FC<CreditorBanksProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('banks', 'Bancos'),
        newText: t('addBank', 'Nuevo banco'),
    }

    return (
        <BaseScreenTableInner TableComponent={TableCreditorBanks} CreateModalComponent={ModalCECreditorBank} EditModalComponent={ModalCECreditorBank} DeleteModalComponent={ModalDeleteCreditorBank} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ SupplierId: basicData?.id }} />
    )
}
interface TableCreditorBanksProps extends TableComponentBaseScreenInnerProps { }

const TableCreditorBanks: React.FC<TableCreditorBanksProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<SupplierBankModelType> = [
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            },
            width: 150
        },
        {
            id: 'defaultBank',
            dataKey: 'defaultBank',
            label: t('default', 'Por defecto'),
            width: 150,
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={75} />
        },
        {
            id: 'iban',
            dataKey: 'iban',
            label: t('iban', 'IBAN'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('iban', 'IBAN'), }
            }
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='creditorBanks' getDataFrom='/api/app/supplier/supplierBank/getAllSupplierBanks' extraWhereParams={{ active: true, ...extraWhereParams }} onRowClick={(_id, rowData) => setOpened({
            type: 'edit',
            allRowData: rowData
        })} setTableInstance={setTableInstance} />
    )
}

export default CreditorBanks